import React, { Component } from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {translate} from "react-i18next";
import ProfileWrapperView from '../ProfileWrapperView';
import {getFormatPrice} from '../../../helpers';
import {DEFAULT_LANGUAGE} from '../../../constants';


class OrderConfirmationView extends Component {

  constructor(props) {
    super(props);
    this.goToPizza = this.goToPizza.bind(this);
    this.state = {...props.location.state}
  }

  componentDidMount() {
    if (!this.state.orderId) {
      this.goToPizza();
    }
    if (localStorage.getItem("pickUpTimeLabel")) {
      localStorage.removeItem("pickUpTimeLabel");
    }
  }

  goToPizza() {
    const {item} = this.props.restaurants;
    let url = '/';
    if (item.name_for_url) {
      const lng = this.props.language.defaultLanguage || DEFAULT_LANGUAGE;
      url = `/${lng}/${item.name_for_url}/products/pizza`;
    }
    this.props.history.push(url);
  }

  render() {
    const { t } = this.props;
    const {orderId, orderTime, userEmail, restaurantName, amount, result} = this.state;
    return (
      <ProfileWrapperView>
        <form className="order-confirm">
          <div className="order-confirm__title">
            {t('order_confirmation')}
          </div>

          <div className="order-confirm__data">
            <div className="order-confirm__data-row">
              <div className="order-confirm__data-name">
                {t('order_number')} :
              </div>
              <div className="order-confirm__data-value">
                {orderId}
              </div>
            </div>
            <div className="order-confirm__data-row">
              <div className="order-confirm__data-name">
                {t('delivery_time')} :
              </div>
              <div className="order-confirm__data-value">
                {orderTime}
              </div>
            </div>
            <div className="order-confirm__data-row">
              <div className="order-confirm__data-name">
                Restaurant :
              </div>
              <div className="order-confirm__data-value">
                {restaurantName}
              </div>
            </div>
          </div>
          <div className="order-confirm__data order-confirm__data--detailed">
            <React.Fragment>
              {[...result].map((obj, index) => (
                <div className="order-confirm__data-row" key={index}>
                    <div className="order-confirm__data-name ">
                      {obj.quantity} x {obj.product.name_en}
                    </div>
                    <div className="order-confirm__data-value">
                      {getFormatPrice(obj.cost)} €
                    </div>
                </div>
              ))}
            </React.Fragment>
            <div className="order-confirm__data-row order-confirm__data-row--total">
              <div className="order-confirm__data-name">
                Total :
              </div>
              <div className="order-confirm__data-value order-confirm__data-value--ttc">
                {getFormatPrice(parseFloat(amount))} €
              </div>
            </div>
          </div>

          <div className="order-confirm__message">
            {t('order_order_to_email')} <strong><a href={`mailto:${userEmail}`}>{userEmail}</a></strong>
          </div>

          <div className="order-confirm__submit">
            <button className="order-confirm__btn" onClick={this.goToPizza}>{t('back')}</button>
          </div>
        </form>
      </ProfileWrapperView>
    );
  }
}

function mapStateToProps(state) {
  return {
    restaurants: state.restaurants,
    language: state.language
  };
}


export default withRouter(connect(mapStateToProps)(translate('translations')(OrderConfirmationView)));


// WEBPACK FOOTER //
// ./src/components/Customer/Order/OrderConfirmView.js